import './accordion.component.scss'
import { ease } from '../../application/utils/ease'

function setEase() {
  document.addEventListener('click', ({ target }) => {
    if (target.closest('.accordion-item__header')) {
      const root = target.closest('.accordion-item')
      const container = root.querySelector('.accordion-item__content')
      if (root) {
        const toggleResult = root.classList.toggle('is-active')
        if (toggleResult) {
          ease.show(container)
        } else {
          ease.hide(container)
        }
      }
    }
  })
}
setEase()